import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ClerkProvider } from "@clerk/clerk-react";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { clerkAppearance } from "./lib/clerkAppearance";
import { getClerkLocalization } from "./lib/clerkLocalization";
import { useLocalization } from "./lib/i18n";
import { queryClient } from "./lib/queryClient";
import "./styles/tailwind.css";
// import "./style3-thin.css";

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!CLERK_PUBLISHABLE_KEY) {
  throw new Error("Missing Clerk Publishable Key");
}

const container = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(container);

function ClerkProviderShell({ children }: { children: React.ReactNode }) {
  const { locale } = useLocalization();

  return (
    <ClerkProvider
      publishableKey={CLERK_PUBLISHABLE_KEY}
      localization={getClerkLocalization(locale)}
      appearance={clerkAppearance}
    >
      {children}
    </ClerkProvider>
  );
}

root.render(
  <React.StrictMode>
    <ClerkProviderShell>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ClerkProviderShell>
  </React.StrictMode>,
);
